function initListSharing() {
  const listSharingBtns = document.querySelectorAll<HTMLButtonElement>(
    "button[data-listing-share]"
  );
  if (listSharingBtns.length === 0) return;

  listSharingBtns.forEach((subscribeButton) => {
    if (!navigator.share) {
      subscribeButton.style.display = "none";
      return;
    }

    subscribeButton.addEventListener("click", () => {
      const shareUrl = window.location.href;
      const shareText = "Check out the shows on PuSh this year!" + "\n" + shareUrl;
      navigator
        .share({
          title: "PuSh Festival",
          text: shareText,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    });
  });
}

initListSharing();
